import React, { type ComponentType, type ComponentPropsWithoutRef, type ReactNode } from 'react';
import { styled as styled2 } from '@compiled/react';
import Button from '@atlaskit/button';
import type { IconSpacing } from '@atlaskit/icon/types';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

export type Action = ComponentPropsWithoutRef<typeof Button> & {
	triggerRef?: React.Ref<HTMLElement>;
	Icon: ComponentType<{
		label: string;
		spacing?: IconSpacing;
	}>;
	label: string;
	iconSpacing?: IconSpacing;
};

export const ActionsButton = (props: Action): React.JSX.Element => {
	const { label, Icon, triggerRef, iconSpacing, ...rest } = props;
	return (
		<Tooltip content={label} position="top">
			<Button
				ref={triggerRef}
				iconBefore={<Icon label={label} spacing={iconSpacing} />}
				{...rest}
			/>
		</Tooltip>
	);
};

export const Actions = (props: { children: ReactNode }): React.JSX.Element => (
	<Wrapper>{props.children}</Wrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled2.div({
	position: 'absolute',
	top: token('space.0'),
	right: token('space.0'),
	display: 'flex',
	marginTop: token('space.150'),
	marginRight: token('space.200'),
	marginBottom: token('space.150'),
	marginLeft: token('space.200'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'> *:not(:last-child)': {
		marginRight: token('space.150'),
	},
});
